const IMAGES: any = {
    fullScreen: require("./svg/FullScreen.svg"),
    nonFullScreen: require("./svg/NonFullScreen.svg"),
    settings: require("./svg/Settings.svg"),
    play: require("./svg/Play.svg"),
    playWhite: require("./svg/PlayWhite.svg"),
    playNext: require("./svg/PlayNext.svg"),
    bigPlay: require("./svg/BigPlay.svg"),
    bigPlayNext: require("./svg/BigPlayNext.svg"),
    bigPlayPrevious: require("./svg/BigPlayPrevious.svg"),
    pause: require("./svg/Pause.svg"),
    bigPause: require("./svg/BigPause.svg"),
    replay: require("./svg/Replay.svg"),
    bigReplay: require("./svg/BigReplay.svg"),
    mute: require("./svg/Mute.svg"),
    unMute: require("./svg/UnMute.svg"),
    backward15: require("./svg/Backward15.svg"),
    forward15: require("./svg/Forward15.svg"),
    defaultMarkersListItemIcon: require("./svg/DefaultPlayListItemIcon.svg"),
    sampleBanner: require("./svg/SampleMultiLive.svg"),
    star: require("./svg/Star.svg"),
    chevronCircleRight: require("./svg/ChevronCircleRight.svg"),
    purpleTick: require("./svg/PurpleTick.svg"),
    pictureInPicture: require("./svg/PictureInPicture.svg"),
    subtitle: require("./svg/Subtitle.svg"),
    subtitleOutline: require("./svg/SubtitleOutline.svg"),
    subtitle1White: require("./svg/Subtitle1White.svg"),
    subtitle1Black: require("./svg/Subtitle1Black.svg"),
    lock: require("./svg/Lock.svg"),
    unlock: require("./svg/Unlock.svg"),
    arrowLeft: require("./svg/ArrowLeft.svg"),
    sun: require("./svg/Sun.svg"),
    scissor: require("./svg/cutter.svg"),
    leftArrow: require("./svg/left-arrow.svg"),
    rightArrow: require("./svg/right-arrow.svg"),
    lightLeftArrow: require("./svg/left-arrow-light.svg"),
    lightRightArrow: require("./svg/right-arrow-light.svg"),
    speed: require("./svg/Speed.svg"),
    emojiHappyWhite: require("./svg/EmojiHappyWhite.svg"),
    emojiHappyBlack: require("./svg/EmojiHappyBlack.svg"),
    keyboardWhite: require("./svg/KeyboardWhite.svg"),
    keyboardBlack: require("./svg/KeyboardBlack.svg"),
    sendCommentTouchScreen: require("./svg/SendCommentTouchScreen.svg"),
    sendCommentDesktopBlack: require("./svg/SendCommentDesktopBlack.svg"),
    sendCommentDesktopWhite: require("./svg/SendCommentDesktopWhite.svg"),
    commentEmptyStateBlack: require("./svg/CommentEmptyStateBlack.svg"),
    commentEmptyStateWhite: require("./svg/CommentEmptyStateWhite.svg"),
    playList: require("./svg/Playlist.svg"),
    starSlash: require("./svg/StarSlash.svg"),
    videoWhite: require("./svg/VideoWhite.svg"),
    videoBlack: require("./svg/VideoBlack.svg"),
    microphoneWhite: require("./svg/MicrophoneWhite.svg"),
    microphoneBlack: require("./svg/MicrophoneBlack.svg"),
    winnerBorder: require("./svg/WinnerBorder.svg"),
    filtersWhite: require("./svg/FiltersWhite.svg"),
    filtersBlack: require("./svg/FiltersBlack.svg"),
    editMarker: require("./svg/edit-marker.svg"),
    trashMarker: require("./svg/trash-marker.svg"),
    trashRed: require("./svg/TrashRed.svg"),
    personalMarkerSign: require("./svg/personalMarker.svg"),
    trashDeleteModal: require("./svg/trash-delete.svg"),
    user1White: require("./svg/User1White.svg"),
    user1Black: require("./svg/User1Black.svg"),
    loginWhite: require("./svg/LoginWhite.svg"),
    cafebazaar: require("./png/cafebazaar.png"),
    myket: require("./png/myket.png"),
    danger: require("./svg/Danger.svg"),
    danger1: require("./png/danger.png"),
    rotateLeft: require("./svg/RotateLeft.svg"),
    clock: require("./png/clock.png"),
    greenTick: require("./png/greenTick.png"),

    curveBottom: require("./svg/CurveBottom.svg"),
    curveTop: require("./svg/CurveTop.svg"),
    cup: require("./svg/Cup.svg"),
    gameOverMagenta: require("./png/gameOverMagenta.png"),
    gameOverBlue: require("./png/gameOverBlue.png"),
    medal: require("./png/medal.png")
};

export default IMAGES;
